<template>
  <div class="profile-contribution-item">
    <div class="content main">
      <svg-icon :name="iconName" kind="indicative" />
      <span class="label">{{ contributionLabel }}</span>
      <cv-link v-if="hasExternalLink" @click="externalLinkClicked">
        <svg-icon name="ExternalLink16" kind="action" />
      </cv-link>
      <span class="number-label">{{ contributionNumberLabel }}</span>
    </div>
    <div v-if="hasSubItem" class="content sub">
      <svg-icon :name="subIconName" kind="indicative" />
      <span class="sub-label">{{ contributionSubLabel }}</span>
      <span class="number-label">{{ contributionNumberSubLabel }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  iconName: string; //Upvote24.svg,Lesson24.svg, Community24.svg, Comment24.svg,
  subIconName?: string; //Upvote16.svg,Lesson24.svg, Community24.svg, Comment24.svg,
  contributionLabel: string;
  contributionSubLabel?: string;
  contributionNumberLabel: number;
  contributionNumberSubLabel?: number;
  hasSubItem?: boolean;
  hasExternalLink?: boolean;
  externalLinkClicked?: () => void;
}

const {
  iconName,
  subIconName,
  contributionLabel,
  contributionSubLabel,
  contributionNumberLabel,
  contributionNumberSubLabel,
  hasSubItem,
  hasExternalLink,
  externalLinkClicked,
} = defineProps<Props>();
</script>

<style lang="scss">
@import "@styles/layout/breakpoint";
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.profile-contribution-item {
  display: flex;
  flex-flow: column;
  justify-content: center;
  min-height: 64px;
  padding: $spacing-05;
  background-color: $ui-background;
  border-radius: 10px;

  @include media("desktop") {
    min-height: 72px;
    padding: $spacing-03 $spacing-05;
  }

  .content {
    display: flex;
    align-items: center;
    gap: $spacing-03;

    &.main {
      .number-label {
        @include carbon--type-style("productive-heading-04");
      }
    }

    &.sub {
      padding-left: $spacing-07;

      .number-label {
        @include carbon--type-style("productive-heading-02");
      }
    }

    .label {
      @include carbon--type-style("productive-heading-01");
      color: $text-02;
    }

    .sub-label {
      @include carbon--type-style("body-short-01");
      color: $text-02;
    }

    .bx--link {
      display: inline-flex;

      .sls-icon {
        [stroke] {
          stroke: $interactive-01;
        }

        [fill] {
          fill: $interactive-01;
        }
      }
    }

    .number-label {
      margin-left: auto;
      color: $interactive-01;
    }
  }
}
</style>
